import { PeriodoCamViewModel } from '../../../_mantenimiento/campanias/periodos/datosbasicos/periodocam.types';

export class NavMenuServicePeriodo {
    protected _currentPeriodo: PeriodoCamViewModel | undefined = new PeriodoCamViewModel();

    protected refresh(): void {
        // TO BE OVERRIDEN IN THE PARENT
    }

    protected resetPeriodoData(): void {
        this._currentPeriodo = new PeriodoCamViewModel();
    }

    protected set currentPeriodo(value: PeriodoCamViewModel) {
        this._currentPeriodo = value;
        this.refresh();
    }

    protected get currentPeriodo(): PeriodoCamViewModel {
        if (!this._currentPeriodo) {
            this._currentPeriodo = new PeriodoCamViewModel();
        }
        return this._currentPeriodo;
    }

    public updateMenuServiceForPeriodo(id: number): void {
        const vm = new PeriodoCamViewModel();
        vm.Id = id;
        this.currentPeriodo = vm;
    }

    public clearMenuServiceForPeriodo(): void {
        const vm = new PeriodoCamViewModel();
        vm.Id = 0;
        this.currentPeriodo = vm;
    }

    protected get isPeriodoSelected(): boolean {
        if (this.currentPeriodo && this.currentPeriodo.Id) {
            return this.currentPeriodo.Id > 0;
        } else return false;
    }
}
